const CardLocation = {
  HAND: "HAND",
  GUN: "GUN",
  IN_PLAY: "IN_PLAY"
};

export { CardLocation };